import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { X } from '@phosphor-icons/react';

const Modal = ({ isOpen, onClose, title, children }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="bg-[#13161e] border border-[#2a2e3d] text-white max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="modal">
        <DialogHeader className="border-b border-[#2a2e3d] pb-4">
          <div className="flex items-center justify-between">
            <DialogTitle className="text-white font-['Fraunces'] text-xl font-bold" data-testid="modal-title">{title}</DialogTitle>
            <button
              onClick={onClose}
              className="text-[#8b949e] hover:text-white transition-colors"
              data-testid="modal-close-button"
            >
              <X size={24} />
            </button>
          </div>
        </DialogHeader>
        <div className="py-4">{children}</div>
      </DialogContent>
    </Dialog>
  );
};

export default Modal;